export function toggleStateButton(state, button) {
  const buttonSubmitLabel = button.querySelector('.label');
  const buttonSubmitSpinner = button.querySelector('.spinner');

  if (state) {
    buttonSubmitLabel.classList.add('!hidden');
    buttonSubmitSpinner.classList.remove('!hidden');
    button.setAttribute('disabled', '');
    return;
  }

  buttonSubmitLabel.classList.remove('!hidden');
  buttonSubmitSpinner.classList.add('!hidden');
  button.removeAttribute('disabled');
}

export function validateInputs(form) {
  const requiredInputs = form.querySelectorAll("input[required], textarea[required]");
  let isValid = true;
  let firstInvalid = null;

  requiredInputs.forEach(input => {
    const errorMsgWrapper = input.closest(".form-control-input").querySelector(".field-error");
    const errorMsgRequired = errorMsgWrapper.dataset.errorRequired;

    if (input.type === "file") {
      const maxFileSizeInBytes = 1024 * 1024 * 2; // 2MB
      const file = input.files?.[0];
      const errorMsgFileSize = errorMsgWrapper.dataset.errorFileSize;

      if (!file) {
        input.setAttribute("aria-invalid", "true");
        errorMsgWrapper.innerText = errorMsgRequired;
        isValid = false;

        if (!firstInvalid) firstInvalid = input;

      } else if (file.size > maxFileSizeInBytes) {
        input.setAttribute("aria-invalid", "true");
        errorMsgWrapper.innerText = errorMsgFileSize;
        isValid = false;

        if (!firstInvalid) firstInvalid = input;

      } else {
        input.removeAttribute("aria-invalid");
        errorMsgWrapper.innerText = "";
      }
      return;
    }

    if (input.value == "") {
      input.setAttribute("aria-invalid", "true");
      errorMsgWrapper.innerText = errorMsgRequired;
      isValid = false;

      if (!firstInvalid) firstInvalid = input;

    } else {
      input.removeAttribute("aria-invalid");
      errorMsgWrapper.innerText = "";
    }
  });

  if (firstInvalid) {
    firstInvalid.focus();
  }

  return isValid;
}
